import { useCallback } from 'react';

import ChevronLeft from '@mui/icons-material/ChevronLeft';

import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';

interface Props {
  anchor?: 'left' | 'right';
  collapsed: boolean;
  onClick: () => void;
}

export function CollapseToggle({ anchor = 'left', collapsed, onClick }: Props) {
  const { transitions } = useTheme();

  const getRotation = useCallback(() => {
    if (anchor === 'left') {
      return collapsed ? 'rotate(180deg)' : 'rotate(0deg)';
    }

    return collapsed ? 'rotate(0deg)' : 'rotate(180deg)';
  }, [anchor, collapsed]);

  return (
    <IconButton
      className={CollapseToggle.className}
      data-testid={`collapse-toggle-${collapsed ? 'open' : 'close'}`}
      onClick={onClick}
      sx={{
        '&:hover': {
          bgcolor: 'nav.evidentBg',
        },
        bgcolor: 'nav.evidentBg',
        border: '1px solid',
        borderColor: 'nav.evidentDivider',
        position: 'absolute',
        top: '50%',
        transform: collapsed
          ? `translate(${anchor === 'left' ? '50%' : '-50%'}, -50%) ${getRotation()}`
          : `translate(${anchor === 'left' ? '50%' : '-50%'}, -50%) ${getRotation()}`,
        transition: `opacity 150ms ${transitions.easing.easeInOut}, transform 150ms ${transitions.easing.easeInOut}`,
        zIndex: 999,
        ...(anchor === 'left' ? { right: 0 } : { left: 0 }),
      }}
    >
      <ChevronLeft />
    </IconButton>
  );
}

CollapseToggle.className = 'shared-collapse-toggle';
